class UrlUtils {
    static isOnView(name) {
       return  window.location.href.includes(name);
    }
     
    static getTokenFromUrl = (url) =>{
        let tokenRegex = /[?&]token=([^&]+)/;
        let match = url.match(tokenRegex);
        let token = '';
        if (match && match[1]) {
            token = match[1];
        }
        return token;
    }
}
export default  UrlUtils;
